import React from "react";
import { useSelector, useDispatch } from "react-redux";

const MyComponent = () => {
  // Access the global variable from the Redux state
  const globalVariable = useSelector((state) => state.globalVariable);

  // Dispatch function to send actions to the store
  const dispatch = useDispatch();

  // Function to update the global variable
  const updateGlobalVariable = () => {
    dispatch({
      type: "SET_GLOBAL_VARIABLE",
      payload: "New Value", // New value for the global variable
    });
  };

  return (
    <div>
      <h1>Global Variable: {globalVariable}</h1>
      <button onClick={updateGlobalVariable}>Update Global Variable</button>
    </div>
  );
};

export default MyComponent;
